import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Towards a WebRTC mesh network with RTCDataChannel",
  "description": "",
  "published": "2018-05-30T00:00:00.000Z",
  "redirect_from": ["/blog/towards-webrtc-mesh-network-rtcdatachannel/swizec/8411"],
  "categories": "Front End, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <lite-youtube {...{
      "videoid": "eU8vJusvsFc",
      "videostartat": "0"
    }}></lite-youtube>
    <p><em parentName="p">{`This is a Livecoding Recap – an almost-weekly post about interesting things discovered while livecoding. Usually shorter than 500 words. Often with pictures. Livecoding happens almost `}<strong parentName="em">{`every Sunday at 2pm PDT`}</strong>{` on multiple channels. You should `}<a parentName="em" {...{
          "href": "https://www.youtube.com/user/theswizec"
        }}>{`subscribe to ￼My Youtube￼ channel`}</a>{` to catch me live.`}</em></p>
    <p>{`It didn't work. We don't have a mesh network yet. But we're so close that I can almost smell it.`}</p>
    <p>{`The ultimate goal is to build a JavaScript library that can connect arbitrary browsers through a mesh network using a sort of blockchain as the algorithm to ensure distributed data correctness. Why? Intellectual curiosity.`}</p>
    <p>{`This slide from my WeAreDevelopers talk 👇`}</p>
    <p>{`Previously we've figured out `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/learning-webrtc-peer-peer-communication-connecting-browsers-different-devices/swizec/8383"
      }}>{`how to connect two browsers running on different computers with a video connection`}</a>{`. Signaling server helps with the initial handshake, then browsers communicate directly using WebRTC. No more server.`}</p>
    <p>{`WebRTC also supports so called data channels using `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/RTCDataChannel"
      }}>{`RTCDataChannel`}</a>{`.`}</p>
    <p>{`It works like this:`}</p>
    <ol>
      <li parentName="ol">{`Use signaling server to establish a peer connection`}</li>
      <li parentName="ol">{`Add a data channel to said connection`}</li>
      <li parentName="ol">{`Send from each side`}</li>
    </ol>
    <p>{`Data can be anything. We're using `}<inlineCode parentName="p">{`"Hello World"`}</inlineCode>{` strings for now, serialized JSON objects later. Rumors say you could send whole files.`}</p>
    <p>{`This all sounds very simple. Even when you look at the code that's required.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/05/rtcdatachannel.png",
        "alt": null
      }}></img></p>
    <p>{`We add a `}<inlineCode parentName="p">{`RTCDataChannel`}</inlineCode>{` to our peer connection and attach a bunch of event handlers. Errors for complaining, messages for printing, and we try to send a message when the channel opens.`}</p>
    <p>{`The cool part is that we can attach this channel `}<em parentName="p">{`before`}</em>{` a connection is fully established.`}</p>
    <p>{`See, both clients finish with saying `}<inlineCode parentName="p">{`Data channel open`}</inlineCode>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/05/datachannelopen.gif",
        "alt": null
      }}></img></p>
    <p>{`But no data is sent or received, and there's no error. 🧐`}</p>
    <p>{`I suspect this is because while the data channel is open, the peer connection itself is not established. That pesky WebRTC lifecycle error about doing some thing or another in the wrong step.`}</p>
    <p>{`This part used to work. Therefore, I must have broken something when deleting a bunch of code that seemed unnecessary.`}</p>
    <p>{`We also generally spent a lot of time mucking around making this lifecycle more robust because it was hella flaky before.`}</p>
    <p>{`Getting close!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      